module.exports = __webpack_public_path__ + "img/decorate.cbeb1317.svg";